import React from 'react';

/**
 * Search term context
 */
export const SearchTermContext = React.createContext('');
